const Module = () => import('./Module.vue')
const Single = () => import('./views/Single.vue')
const Double = () => import('./views/Double.vue')
const Trading = () => import('./views/Trading.vue')
const Adwin = () => import('./views/Adwin.vue')
const Heatmap = () => import('./views/Heatmap.vue')

const moduleRoute = {
  path: '/chart',
  component: Module,
  redirect: '/chart/single',
  children: [
    {
      path: 'single',
      name: 'chart',
      component: Single,
      meta: {
        subTitle: 'Biểu đồ',
      },
    },
    {
      path: 'compare',
      name: 'chart-compare',
      component: Double,
      meta: {
        is_pro: true,
      },
    },
    {
      path: 'trading-money',
      name: 'chart-trading-money',
      component: Trading,
      meta: {
        variant: 'money',
        premiumFeatures: ['trading-chart'],
      },
    },
    {
      path: 'trading-adwin',
      name: 'chart-trading-adwin',
      component: Trading,
      meta: {
        variant: 'adwin',
        premiumFeatures: ['adwin-chart'],
      },
    },
    {
      path: 'adwin',
      name: 'chart-adwin',
      component: Adwin,
    },
    {
      path: 'heatmap-money',
      name: 'chart-heatmap-money',
      component: Heatmap,
      meta: {
        variant: 'money',
        premiumFeatures: ['money-flow-heatmap'],
      },
    },
    {
      path: 'heatmap-adwin',
      name: 'chart-heatmap-adwin',
      component: Heatmap,
      meta: {
        variant: 'adwin',
        premiumFeatures: ['adwin-heatmap'],
      },
    },
  ],
}

export default router => {
  router.addRoute(moduleRoute)
}
